import { render, staticRenderFns } from "./StockLog.vue?vue&type=template&id=71898ddb&scoped=true&"
import script from "./StockLog.vue?vue&type=script&lang=js&"
export * from "./StockLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71898ddb",
  null
  
)

export default component.exports